var company = {};
module['exports'] = company;
company.suffix = require("./suffix");



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_AU/company/index.js
// module id = 650
// module chunks = 0